// import {doesContain} from './utils';
// import regBtnClick from './registration';
// import {authBtnClick} from './auth';
// //import showModalRegistration from './showmodalregistration';

import {is_touch_device as isMobile} from './services';
import initGallery from './init-gallery';
import initSwiper from './initSwiper';
import showMore from './more';
import submitForm from './submitForm';
import modal from './modal';
import popup from './popup';
import videoDownload from './video-download';
// window.addEventListener('load', regBtnClick);
// window.addEventListener('load', authBtnClick);
// //window.addEventListener('load', getCertificateBtnClick);
// window.addEventListener('load', searchMenuInit);
// window.addEventListener('DOMContentLoaded', searchFieldsInit);
// window.addEventListener('load', reviewMore);

(function initApp() {
    window.addEventListener('load', function() {
        if (document.querySelector('.js-gallery') && isMobile() && window.matchMedia("(max-width: 600px)").matches) {
            //инициализируем слайдер галереи на детальной странице отеля только на мобильных
            initGallery();
        }
        if (document.querySelector('.dmc-slider')) {
            initSwiper();
        }
        
        const submitBtn = document.querySelectorAll('.js-submit');
        if (submitBtn) {
            submitForm(submitBtn);   
        }
        const modalTriggers = document.querySelectorAll('[data-modal]');
        if (modalTriggers.length > 0) {
            modalTriggers.forEach(function(item) {
                item.addEventListener('click', modal);
            })
        }
        const popupTriggers = document.querySelectorAll('[data-popup]');
        if (popupTriggers.length > 0) {
            popupTriggers.forEach(function(item) {
                item.addEventListener('click', popup);
            })
        }
        showMore();
        videoDownload();
    })
}())






// Swiper.use([Pagination]);

// (function initSwiper() {
//     const switchers = document.querySelectorAll('.js-switch');
//     const swiperContainer = document.querySelector('.swiper-container');

//     function is_touch_device() {
//         var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
//         var mq = function(query) {
//             return window.matchMedia(query).matches;
//         }
    
//         if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
//             return true;
//         }
    
//         // include the 'heartz' as a way to have a non matching MQ to help terminate the join
//         // https://git.io/vznFH
//         var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
//         return mq(query);
//     }
    
//     if (switchers) {
//         switchers.forEach( elem => {
//             elem.addEventListener('click', function() {
//                 const key = this.dataset.target;
//                 const id = `switch-${key}`;
//                 document.querySelectorAll('.js-switchbox input').forEach(elem => {
//                     elem.checked = false;
//                 })
//                 document.getElementById(id).checked = true;
                
//             });
//         })
//     }
// //добавить && совпадение по viewport
//     if (swiperContainer && is_touch_device() && window.matchMedia("(max-width: 600px)").matches) {
//         new Swiper(swiperContainer, {
//             loop: true,
//             slidesPerView: 'auto',
//             // centeredSlides: true,
//             spaceBetween: 10,
//             pagination: {
//                 el: '.swiper-pagination',
//                 dynamicBullets: false,
//             },
//         });
//     }

// }());